<template>
  <div>
    <el-dialog :title="title" :close-on-click-modal="false" :visible.sync="dialogVisible" width="1580px" center>
      <div class="content">
        <div class="row">
          <div class="item">
            <div class="val">
              <el-input v-model="datas.keyword" onfocus="this.select()" type="text" placeholder="历史配送单号"></el-input>
            </div>
          </div>
          <div class="item">
            <div class="val">
              <el-input v-model="datas.keyword" onfocus="this.select()" type="text" placeholder="地址-氏名"></el-input>
            </div>
          </div>
          <el-button type="primary" @click="historyDeliveryAddressList">搜索</el-button>
        </div>
        <div class="table">
          <ol>
            <li>会社</li>
            <li>会社名（ローマ字）</li>
            <li>郵便</li>
            <li>住所</li>
            <li>住所(ローマ字)</li>
            <li>氏名</li>
            <li>氏名(ローマ字)</li>
            <li>携帯番号</li>
            <li>固定電話</li>
            <li>法人番号</li>
            <li>リアルタイム口座</li>
            <li>標準コード</li>
            <li>操作</li>
          </ol>
          <ul v-for="item in tableData" :key="item.id">
            <li>{{ item.company }}</li>
            <li>{{ item.company_roma }}</li>
            <li>{{ item.zip_code }}</li>
            <li>{{ item.address }}</li>
            <li>{{ item.address_roma }}</li>
            <li>{{ item.contacts }}</li>
            <li>{{ item.contacts_roma }}</li>
            <li>{{ item.mobile }}</li>
            <li>{{ item.tel }}</li>
            <li>{{ item.tax_no }}</li>
            <li>{{ item.bank_no }}</li>
            <li>{{ item.standard_no }}</li>
            <li>
              <el-button type="primary" size="mini" @click="useAddress(item)">使用</el-button>
            </li>
          </ul>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      title: '',
      datas: {
        keyword: '',
        porder_sn: '',
        match_porder_sn: '',
        type: '',
        user_id: '',
      },
      tableData: [],
      dialogVisible: false,
    };
  },
  methods: {
    // 获取历史地址列表
    historyDeliveryAddressList() {
      this.$api.porderApi.historyDeliveryAddressList(this.datas).then(res => {
        this.tableData = res.data
      })
    },
    // 选择历史地址并回填到父组件表单
    useAddress(item) {
      this.$emit('use-address', item, this.datas.type)
      this.dialogVisible = false
    },
  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0px 15px;

  .row {
    display: flex;
    margin-bottom: 20px;

    .item {
      width: 220px;
      margin-right: 20px;
    }
  }

  .table {
    border: 1px solid #edeff4;
    max-height: 600px;
    overflow: auto;

    ol,
    ul {
      display: flex;
    }

    ul {
      padding: 0;

      li {
        padding: 24px 0;
      }
    }

    li {
      flex: 1;
      border-right: 1px solid #edeff4;
      word-break: break-all;

      &:nth-last-child(1) {
        border: 0;
      }
    }
  }
}
</style>
